import React from 'react';
import { ShieldCheckIcon, MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
export function Footer() {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();
  const scrollToSection = (id: string) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  const scrollToTop = () => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }, 100);
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };
  return <footer className="relative py-12 px-4 sm:px-6 lg:px-8 overflow-hidden bg-black border-t border-zinc-900" data-id="element-164">
      <div className="max-w-7xl mx-auto" data-id="element-165">
        {/* CTA Section */}
        <div className="text-center mb-16 pb-12 border-b border-zinc-900" data-id="element-166">
          <a href="/application" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-black bg-white rounded-lg hover:bg-zinc-100 transition-all duration-200 shadow-lg hover:shadow-xl" data-id="element-167">
            Get Started Now
          </a>
        </div>

        <div className="grid md:grid-cols-4 gap-12 mb-12" data-id="element-168">
          {/* Column 1: Company */}
          <div data-id="element-169">
            <h3 className="text-1xl font-bold mb-6 text-white tracking-tight" data-id="element-170">
              VCA CAPITAL ADVISORS INC.
            </h3>
            <p className="text-white mb-6 text-sm leading-relaxed max-w-xs" data-id="element-171">
              Empowering businesses with flexible capital solutions.
            </p>
            <div className="flex items-center gap-2 text-sm text-zinc-500" data-id="element-172">
              <ShieldCheckIcon className="w-5 h-5 text-white" data-id="element-173" />
              <span data-id="element-174">Secure & Confidential</span>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div data-id="element-175">
            <h4 className="font-bold text-lg mb-6 text-white" data-id="element-176">Quick Links</h4>
            <ul className="space-y-3 text-zinc-400 text-sm" data-id="element-177">
              <li data-id="element-178">
                <button onClick={scrollToTop} className="hover:text-white transition-colors cursor-pointer text-left" data-id="element-179">
                  Home
                </button>
              </li>
              <li data-id="element-180">
                <button onClick={() => scrollToSection('about')} className="hover:text-white transition-colors cursor-pointer text-left" data-id="element-181">
                  About Us
                </button>
              </li>
              <li data-id="element-182">
                <button onClick={() => scrollToSection('how-it-works')} className="hover:text-white transition-colors cursor-pointer text-left" data-id="element-183">
                  How It Works
                </button>
              </li>
              <li data-id="element-184">
                <button onClick={() => scrollToSection('faq')} className="hover:text-white transition-colors cursor-pointer text-left" data-id="element-185">
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          {/* Column 3: Funding Types */}
          <div data-id="element-186">
            <h4 className="font-bold text-lg mb-6 text-white" data-id="element-187">
              Funding Options
            </h4>
            <ul className="space-y-3 text-zinc-400 text-sm" data-id="element-188">
              <li data-id="element-189">
                <button onClick={() => scrollToSection('services')} className="hover:text-white transition-colors cursor-pointer text-left" data-id="element-190">
                  SBA Loans
                </button>
              </li>
              <li data-id="element-191">
                <button onClick={() => scrollToSection('services')} className="hover:text-white transition-colors cursor-pointer text-left" data-id="element-192">
                  Business Lines of Credit
                </button>
              </li>
              <li data-id="element-193">
                <button onClick={() => scrollToSection('services')} className="hover:text-white transition-colors cursor-pointer text-left" data-id="element-194">
                  Equipment Financing
                </button>
              </li>
              <li data-id="element-195">
                <button onClick={() => scrollToSection('services')} className="hover:text-white transition-colors cursor-pointer text-left" data-id="element-196">
                  Working Capital
                </button>
              </li>
              <li data-id="element-197">
                <button onClick={() => scrollToSection('services')} className="hover:text-white transition-colors cursor-pointer text-left" data-id="element-198">
                  Cash Advance
                </button>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact Us */}
          <div data-id="element-199">
            <h4 className="font-bold text-lg mb-6 text-white" data-id="element-200">Contact Us</h4>
            <ul className="space-y-4 text-sm" data-id="element-201">
              <li data-id="element-202">
                <a href="mailto:info@vcacapitaladvisors.com" className="flex items-start gap-3 text-zinc-400 hover:text-white transition-colors" data-id="element-203">
                  <MailIcon className="w-4 h-4 text-white mt-0.5 shrink-0" data-id="element-204" />
                  info@vcacapitaladvisors.com
                </a>
              </li>
              <li data-id="element-205">
                <a href="tel:646-331-2752" className="flex items-start gap-3 text-zinc-400 hover:text-white transition-colors" data-id="element-206">
                  <PhoneIcon className="w-4 h-4 text-white mt-0.5 shrink-0" data-id="element-207" />
                  (646) 331-2752
                </a>
              </li>
              <li data-id="element-208">
                <div className="flex items-start gap-3 text-zinc-400" data-id="element-209">
                  <MapPinIcon className="w-4 h-4 text-white mt-0.5 shrink-0" data-id="element-210" />
                  <span data-id="element-211">
                    2248 Broadway STE 1784
                    <br data-id="element-212" />
                    New York, NY 10024
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-zinc-900 pt-8 flex flex-col justify-center items-center text-xs text-white space-y-2" data-id="element-213">
          <p data-id="element-214">© {currentYear} VCA Capital Advisors Inc. All rights reserved.</p>
          <div className="flex space-x-8" data-id="element-215">
            <a href="/privacy" className="hover:text-zinc-300 transition-colors" data-id="element-216">
              Privacy Policy
            </a>
            <a href="/terms" className="hover:text-zinc-300 transition-colors" data-id="element-217">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}